import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import ReactMarkdown from "react-markdown";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { BackgroundPolicy } from "../../components/background";

import "./styles.css";

function PrivacePolicyPage() {
  const { t, i18n } = useTranslation();
  const [content, setContent] = useState("");

  useEffect(() => {
    const lang = i18n.language.toLowerCase().startsWith("en") ? "en" : "pt-br";
    fetch(`/content/privace-policy/${lang}.md`)
      .then((r) => r.text())
      .then((text) => setContent(text));
  }, [i18n.language]);

  return (
    <div className="App">
      <BackgroundPolicy />
      <div className="privace-policy-page-container">
        <Header />
        <div className="privace-policy-content-container">
          <h1>{t("privacyPolicy.headline")}</h1>
          <div className="privace-policy-wrapper">
            <div className="privace-policy-text-container">
              <div className="privace-policy-text-content">
                <ReactMarkdown>{content}</ReactMarkdown>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

function PrivacePolicyPopup({ closePolicyPopup }) {
  const { i18n } = useTranslation();
  const [content, setContent] = useState("");

  useEffect(() => {
    const lang = i18n.language === "en" ? "en" : "pt-br";
    import(`/public/content/privace-policy/${lang}.md`)
      .then((res) => fetch(res.default).then((r) => r.text()))
      .then((text) => setContent(text));
  }, [i18n.language]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className="modal-overlay" onClick={closePolicyPopup}>
      <div className="modal-text-container">
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close-button" onClick={closePolicyPopup}>
            &times;
          </button>
          <div className="modal-text">
            <ReactMarkdown>{content}</ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  );
}

export { PrivacePolicyPage, PrivacePolicyPopup };
